import { render, staticRenderFns } from "./Talents.vue?vue&type=template&id=3882da50&"
import script from "./Talents.vue?vue&type=script&lang=js&"
export * from "./Talents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports